import { isNZLocale } from 'lib/PropertyUtils';

const LISTING_TYPE_AU = [
    { label: 'Normal Sale', value: 'Normal Sale' },
    { label: 'Auction', value: 'Auction' },
    { label: 'Tender', value: 'Tender' },
    { label: 'Mortgagee Sale', value: 'Mortgagee Sale' },
    { label: 'Offers', value: 'Offers' },
    { label: 'Unknown', value: 'Unknown' },
];

const LISTING_TYPE_NZ = [
    { label: 'Asking Price', value: 'Asking Price' },
    { label: 'Auction', value: 'Auction' },
    { label: 'By Negotiation', value: 'By Negotiation' },
    { label: 'Enquiries Over', value: 'Enquiries Over' },
    { label: 'Mortgagee Sale', value: 'Mortgagee Sale' },
    { label: 'Deadline Private Treaty', value: 'Deadline Private Treaty' },
    { label: 'Tender', value: 'Tender' },
    { label: 'Unknown', value: 'Unknown' },
];

export default isNZLocale() ? LISTING_TYPE_NZ : LISTING_TYPE_AU;